export default __webpack_public_path__ + "static/media/student.a360110d.svg";